import { useNavigate } from 'react-router-dom';
import { Table, StatusBadge, ActionCell, Button } from '@components/ui';
import { Building, Trash2, ChevronRight, Scale } from 'lucide-react';
import { getCariAccountByCompanyId } from '@mocks/cariHesaplar';
import clsx from 'clsx';

export default function CompaniesTable({ data, onDelete }) {
    const navigate = useNavigate();

    const formatCurrency = (amount) => {
        if (!amount) return '-';
        return new Intl.NumberFormat('tr-TR', {
            style: 'currency',
            currency: 'TRY',
            minimumFractionDigits: 0,
        }).format(amount);
    };

    const getTypeVariant = (type) => {
        const variants = {
            subcontractor: 'info',
            supplier: 'secondary',
            service: 'tertiary',
        };
        return variants[type] || 'default';
    };

    const columns = [
        {
            key: 'shortName',
            header: 'Firma',
            width: 'lg',
            render: (val, row) => (
                <button
                    className="font-medium text-primary hover:underline text-left cursor-pointer"
                    onClick={() => navigate(`/finans/firmalar/${row.id}`)}
                >
                    {val || row.name}
                </button>
            ),
        },

        {
            key: 'typeLabel',
            header: 'Tip',
            width: 'sm',
            align: 'center',
            render: (val, row) => (
                <StatusBadge status={val} variant={getTypeVariant(row.type)} />
            ),
        },
        {
            key: 'specialty',
            header: 'Uzmanlık',
            width: 'lg',
            render: (val) => <span className="text-text-secondary truncate max-w-[200px] block">{val}</span>,
        },
        {
            key: 'id',
            header: 'Cari Bakiye',
            width: 'md',
            align: 'center',
            render: (val) => {
                const cari = getCariAccountByCompanyId(val);
                if (!cari) return <span className="text-text-muted text-xs">—</span>;
                return (
                    <button
                        type="button"
                        onClick={(e) => { e.stopPropagation(); navigate(`/finans/cari`); }}
                        className={clsx(
                            'flex items-center gap-1.5 text-xs font-semibold px-2 py-1 rounded-lg transition-colors mx-auto',
                            cari.currentBalance > 0
                                ? 'bg-error/10 text-error hover:bg-error/20'
                                : 'bg-success/10 text-success hover:bg-success/20'
                        )}
                    >
                        <Scale size={11} />
                        {cari.currentBalance > 0 ? formatCurrency(cari.currentBalance) : 'Kapalı'}
                    </button>
                );
            },
        },
        {
            key: 'actions',
            header: '',
            width: 'sm',
            align: 'center',
            render: (val, row) => (
                <ActionCell>
                    <Button
                        variant="ghost"
                        size="xs"
                        onClick={() => navigate(`/finans/firmalar/${row.id}`)}
                    >
                        <ChevronRight size={16} />
                    </Button>
                    <Button
                        variant="ghost-error"
                        size="xs"
                        onClick={(e) => {
                            e.stopPropagation();
                            onDelete?.(row);
                        }}
                    >
                        <Trash2 size={16} />
                    </Button>
                </ActionCell>
            ),
        },
    ];

    return (
        <Table
            columns={columns}
            data={data}
            showRowNumbers
            onRowClick={(row) => navigate(`/finans/firmalar/${row.id}`)}
            emptyMessage="Firma bulunamadı."
            emptyIcon={<Building size={40} />}
        />
    );
}
